import { render, staticRenderFns } from "./QuoteLimitLowerRuleDia.vue?vue&type=template&id=5f11f578&scoped=true"
import script from "./QuoteLimitLowerRuleDia.vue?vue&type=script&lang=js"
export * from "./QuoteLimitLowerRuleDia.vue?vue&type=script&lang=js"
import style0 from "./QuoteLimitLowerRuleDia.vue?vue&type=style&index=0&id=5f11f578&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f11f578",
  null
  
)

export default component.exports